import React, { useEffect, useState, useCallback } from "react";
import shape from "../../assets/images/shopping-arrow.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faPlus, faSpinner, faCheck } from "@fortawesome/free-solid-svg-icons";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { api } from "../../Constant";
import { faAngleRight, faXmark } from "@fortawesome/free-solid-svg-icons";

import { useParams, useLocation } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const Buynow = () => {
    const location = useLocation();  // ✅ Add this
    const [addressList, setAddressList] = useState([]);
    const [productData, setProductData] = useState(null);
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showAddressForm, setShowAddressForm] = useState(false);
    const [error, setError] = useState(null);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);


    const [productId, setProductId] = useState(null);
    const [size, setSize] = useState(location.state?.size || "");
    // console.log("currenr size =", size);
    const [quantity, setQuantity] = useState(1);

    const [couponDetail, setCouponDetail] = useState(null);
    const [showCoupon, setShowCoupon] = useState(true);

    //  razor payment 

    const [isLoading, setIsLoading] = useState(false);

    const [disablePay, setDisablePay] = useState(false);

    const [fieldErrors, setFieldErrors] = useState({});


    const handlePayment = async () => {
        if (!productData?.product) {
            alert("Product data not available.");
            return;
        }

        setIsLoading(true);

        try {
            const payload = buildPaymentPayload();

            // Make sure Razorpay script is ready
            if (!window.Razorpay) {
                alert("Razorpay SDK not loaded!");
                setIsLoading(false);
                return;
            }

            // Step 1: Hit pay_now API to initialize order
            const initResponse = await axios.post(`${api}pay_now`, payload);

            console.log("PAY NOW INIT RESPONSE:", initResponse.data);

            const isSuccess = initResponse.data.success === true || initResponse.data.success === "true";

            if (!isSuccess) {
                alert(initResponse.data.message || "Payment initialization failed.");
                return;
            }

            // Step 2: Open Razorpay checkout
            const options = {
                key: "rzp_live_RSwLSAE4MVSJTz",
                 // key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_vmxoAc8eMJjXS5",
                amount: Math.round(payload.total * 100),
                currency: "INR",
                name: "Little Love Nature",
                description: "Payment",

                handler: async function (paymentResponse) {
                    // ✅ Payment completed on Razorpay
                    const paymentId = paymentResponse.razorpay_payment_id;
                    const orderId = initResponse.data.order_id; // your backend order id
                    const userId = localStorage.getItem("userId"); // or wherever you store it

                    // console.log("Payment ID:", paymentId);
                    // console.log("Order ID:", orderId);

                    // Step 3: Call your backend again to verify & confirm
                    try {
                        const verifyResponse = await axios.post(`${api}pay_now`, {
                            payment_id: paymentId,
                            order_id: orderId,
                            user_id: userId,
                        });

                        if (verifyResponse.data.success === true || verifyResponse.data.success === "true") {
                            // alert("Payment verified & order confirmed!");
                            navigation("/Order-success", { state: { orderId } });
                        } else {
                            alert(verifyResponse.data.message || "Payment succeeded but order confirmation failed.");
                        }
                    } catch (err) {
                        console.error("Backend verification error:", err);
                        alert(err.response?.data?.message || "Server error during payment verification.");
                    }
                },

                prefill: {
                    name: localStorage.getItem("userName") || "Guest User",
                    email: localStorage.getItem("userEmail"),
                    contact: localStorage.getItem("userPhone"),
                },

                theme: { color: "#227070" },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (error) {
            console.error("Payment error:", error);
            alert(error.message || "Something went wrong.");
        } finally {
            setIsLoading(false);
        }
    };



    const coupannav = () => {
        navigation("/Coupouns");
        localStorage.setItem("totalamnt", productData?.total_amount);
    };

    const removeCoupon = () => {
        setCouponDetail(null);
        setShowCoupon(true);
        localStorage.removeItem("coupon_id");
    };

    useEffect(() => {
        const couponId = localStorage.getItem("coupon_id");

        if (!productData?.total_amount || !couponId) {
            setCouponDetail(null);
            setShowCoupon(true);
            return;
        }

        axios.post(`${api}Coupon_discount_details`, {
            total_amount: productData.total_amount,
            coupon_id: couponId
        })
            .then(response => {
                if (response.data.success === "true") {
                    setCouponDetail(response.data.coupons);
                    setShowCoupon(false);
                } else {
                    removeCoupon();
                }
            })
            .catch(() => removeCoupon());
    }, [productData?.total_amount]);


    useEffect(() => {
        if (location.state?.size) {
            setSize(location.state.size);
        }
    }, [location.state]);

    useEffect(() => {
        const fetchStates = async () => {
            try {
                const response = await fetch(api + 'state_list', { method: 'POST' });
                const data = await response.json();
                if (data.success === "true") {
                    // Note: API returns data in a 'product' key.
                    setStates(data.product || []);
                } else {
                    console.error('Failed to fetch states:', data.message);
                }
            } catch (error) {
                console.error('Error fetching states:', error);
            }
        };
        fetchStates();
    }, []);

    const { id } = useParams();
    useEffect(() => {
        setProductId(id);
    }, [id]);

    // product details API 


    // NEW — for edit mode
    const [editMode, setEditMode] = useState(false);
    const [editAddressId, setEditAddressId] = useState(null);

    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        address: "",
        state: "",
        city: "",
        pin_code: "",
        email_id: "",
        phone_number: ""
    });

    const navigation = useNavigate();

    const ensureGuestId = () => {

        let guestId = localStorage.getItem("guest_id");
        const userId = localStorage.getItem("userId");


        if (!guestId && !userId) {
            guestId = `guest_${Date.now()}`;
            localStorage.setItem("guest_id", guestId);
        }
        return { userId, guestId };
    };

    const getIdentifier = useCallback(() => {
        const { userId, guestId } = ensureGuestId();

        if (guestId && userId === guestId) return { guest_id: guestId };
        if (userId) return { user_id: userId };
        if (guestId) return { guest_id: guestId };

        return null;
    }, []);


    // ✅ Place buildPaymentPayload here

    const buildPaymentPayload = () => {
        const identifier = getIdentifier();
        const productAmount = productData.product.discount_price && productData.product.discount_price > 0
            ? productData.product.discount_price
            : productData.product.price;

        const finalAmount = (productData.total_amount || 0) - (couponDetail?.discounted_amount || 0);

        return {
            ...identifier,
            address_id: selectedCardId,
            coupon_id: localStorage.getItem("coupon_id"),
            coupon_discount: couponDetail?.discounted_amount || 0,
            shipping_charges: productData?.shipping_charges || 0,   // ✅ correct field name
            total: finalAmount,
            product_details: [{
                product_id: productData.product.product_id,
                quantity: productData.product.selected_quantity,
                product_amount: productAmount,
                product_total: productData.product_total,
            }]
        };
    };


    // ---------------- Fetch Address ----------------
    const fetchAddresses = useCallback(async () => {
        const identifier = getIdentifier();
        if (!identifier) return;

        try {
            const addressParams = {
                ...identifier,
                product_id: productId,
                quantity: quantity
            };

            const res = await axios.post(api + "address_list", addressParams);
            if (res.data.success === "true") {
                setAddressList(res.data.address);

                // auto-select active or first
                const active =
                    res.data.address.find(a => a.active_status === "Active") ||
                    res.data.address[0];

                if (active) {
                    setSelectedCardId(active.address_id);

                    // ✅ Only check shipping status if NOT adding a new address
                    if (!showAddressForm) {
                        if (active.shipping_status === 0) {
                            setError("Delivery is not available for this pincode");
                            setDisablePay(true);
                        } else {
                            setError(null);
                            setDisablePay(false);
                        }
                    }
                }
            }


        } catch (err) {
            console.error("fetchAddresses error:", err);
        }
    }, [getIdentifier, productId, quantity]);

    useEffect(() => {
        if (productId) {
            fetchAddresses();
        }
    }, [productId, quantity]);

    // 🔹 Then your initLoad and refreshData effects come below
    useEffect(() => {
        const initLoad = async () => {
            setLoading(true);
            await fetchAddresses();
            await fetchProduct();
            setLoading(false);
        };
        initLoad();
    }, []);

    useEffect(() => {
        const refreshData = async () => {
            await fetchProduct();
        };
        if (selectedCardId && productId) {
            refreshData();
        }
    }, [selectedCardId, productId, size, quantity]);


    // ---------------- Activate Address ----------------
    const selectCard = async (id) => {
        const identifier = getIdentifier();
        setSelectedCardId(id);

        try {
            await axios.post(api + "address_active", {
                ...identifier,
                address_id: id
            });
            await fetchAddresses();
        } catch (err) {
            console.error("address_active error:", err);
        }
    };

    // ---------------- Delete Address ----------------
    const handleRemoveAddress = async (e, id) => {
        e.stopPropagation();
        const identifier = getIdentifier();

        const backup = [...addressList];
        setAddressList(prev => prev.filter(a => a.address_id !== id));

        try {
            const res = await axios.post(api + "delete_address", {
                ...identifier,
                address_id: id
            });

            if (res.data.success !== "true") {
                setAddressList(backup);
            } else {
                await fetchAddresses();
            }
        } catch (err) {
            console.error("delete_address error:", err);
            setAddressList(backup);
        }
    };

    // ---------------- Handle Add or Update ----------------
    const handleSubmit = async () => {
        const identifier = getIdentifier();

        // Validate required fields
        if (
            !form.first_name ||
            !form.address ||
            !form.phone_number ||
            !form.pin_code ||
            !form.state ||
            !form.city
        ) {
            setError("Please fill all required fields including state and city.");
            return;
        }

        try {
            let res;

            if (editMode) {
                // ------------ UPDATE ADDRESS ------------
                res = await axios.post(api + "update_address", {
                    ...identifier,
                    ...form,
                    address_id: editAddressId
                });
            } else {
                // ------------ ADD ADDRESS ------------
                res = await axios.post(api + "add_address", {
                    ...identifier,
                    ...form
                });
            }

            if (res.data.success === "true") {
                setTimeout(() => {
                    toast.success(
                        editMode
                            ? "Address updated successfully"
                            : "Address submitted successfully"
                    );
                }, 300);

                await fetchAddresses();
                const newAddress = res.data.address; // backend usually returns the saved address
                if (newAddress?.shipping_status === 0) {
                    setError("Delivery is not available for this pincode");
                    setDisablePay(true);
                } else {
                    setError(null);
                    setDisablePay(false);
                }
                setShowAddressForm(false);
                setEditMode(false);
                setEditAddressId(null);
                setForm({
                    first_name: "",
                    last_name: "",
                    address: "",
                    state: "",
                    city: "",
                    pin_code: "",
                    email_id: "",
                    phone_number: ""
                });
                setError(null);
            } else {
                setError("Action failed.");
            }
        } catch (err) {
            console.error("address submit error:", err);

            const apiErrors = err.response?.data?.error;

            if (apiErrors) {
                if (apiErrors.pin_code?.length) {
                    setError(apiErrors.pin_code[0]);
                } else if (apiErrors.phone_number?.length) {
                    setError(apiErrors.phone_number[0]); // ✅ "The phone number must be 10 digits."
                } else {
                    // fallback: show first error message if any
                    const firstErrorKey = Object.keys(apiErrors)[0];
                    setError(apiErrors[firstErrorKey][0]);
                }
            } else if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError("Something went wrong. Please try again.");
            }
        }
    };

    // ---------------- Edit Button Click ----------------
    const handleEdit = (e, address) => {
        e.stopPropagation();

        // 🔍 Find matching state by name
        const foundState = states.find(s => s.state_name === address.state);
        const stateId = foundState ? foundState.state_id : "";

        // 🔍 Load cities for that state BEFORE setting city
        const loadCities = async () => {
            try {
                const response = await fetch(api + 'city_list', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ state_id: stateId }),
                });

                const data = await response.json();

                if (data.success === "true") {
                    setCities(data.product || []);

                    // 🔍 Find matching city by name
                    const foundCity = data.product.find(c => c.city_name === address.city);
                    const cityId = foundCity ? foundCity.city_id : "";

                    // ✅ Finally set form with correct IDs
                    setForm({
                        first_name: address.first_name || "",
                        last_name: address.last_name || "",
                        address: address.address || "",
                        state: stateId,      // ✔ correct ID
                        city: cityId,        // ✔ correct ID
                        pin_code: address.pin_code || "",
                        email_id: address.email_id || "",
                        phone_number: address.phone_number || ""
                    });
                }
            } catch (err) {
                console.error("City load error on edit:", err);
            }
        };

        setEditMode(true);
        setEditAddressId(address.address_id);
        setShowAddressForm(true);

        // Load cities first, then set city
        if (stateId) {
            loadCities();
        }
    };


    useEffect(() => {
        const fetchCities = async (stateId) => {
            try {
                const response = await fetch(api + 'city_list', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ state_id: stateId }),
                });
                const data = await response.json();
                if (data.success === "true") {
                    setCities(data.product || []);
                } else {
                    console.error('Failed to fetch cities:', data.message);
                    setCities([]);
                }
            } catch (error) {
                console.error('Error fetching cities:', error);
                setCities([]);
            }
        };

        if (form.state) {
            fetchCities(form.state);
        } else {
            setCities([]);
        }
    }, [form.state]);



    // ---------------- Fetch Product ----------------

    const fetchProduct = async () => {
        try {
            const res = await axios.post(api + "single_product", {
                ...getIdentifier(),
                address_id: selectedCardId,
                product_id: productId,
                size: size,
                quantity: quantity
            });
            // console.log("API response:", res.data);
            if (res.data.success === "true") {
                setProductData(res.data);
            }
            else {
                console.error("Product fetch failed:", res.data.error);
            }
        } catch (err) {
            console.error("fetchProduct error:", err);
            // } finally {
            //     setLoading(false); 
            // }
        };
    }

    if (loading) {
        return (
            <div className="full-page-loader">
                <div className="spinner"></div>
            </div>
        );
    }

    // <div className="buynow-page">
    //     {!editMode && error && (
    //         <div className="error-message">{error}</div>
    //     )}


    //     {/* rest of your BuyNow JSX */}
    // </div>

    return (
        <>

            <ToastContainer position="top-right" autoClose={3000} />
            <section>
                <div className="billingpage-bg pt-40 pb-40">
                    <div className="container">
                        <div className="row">



                            {/* LEFT SIDE */}
                            <div className="col-lg-8">

                                <div
                                    className="add-address-tittle"
                                    onClick={() => {
                                        setShowAddressForm(prev => !prev);
                                        setEditMode(false);
                                        setError(null);
                                        setForm({
                                            first_name: "",
                                            last_name: "",
                                            address: "",
                                            state: "",
                                            city: "",
                                            pin_code: "",
                                            email_id: "",
                                            phone_number: ""
                                        });
                                    }}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="plus-bg"><FontAwesomeIcon icon={faPlus} /></div>
                                    <h5>{editMode ? "Edit Address" : "Add New Address"}</h5>
                                </div>

                                {/* ADDRESS FORM */}
                                {showAddressForm && (
                                    <div className="address-form-box mt-4">
                                        <h4>{editMode ? "Edit Address" : "Add New Address"}</h4>

                                        {error && <div style={{ color: "red" }}>{error}</div>}

                                        <div className="row">
                                            {/* FIRST NAME */}
                                            <div className="col-lg-6 mb-3">
                                                <label>
                                                    First Name <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="First Name"
                                                    value={form.first_name}
                                                    onChange={(e) => setForm({ ...form, first_name: e.target.value })}
                                                />
                                            </div>

                                            {/* LAST NAME */}
                                            <div className="col-lg-6 mb-3">
                                                <label>
                                                    Last Name <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Last Name"
                                                    value={form.last_name}
                                                    onChange={(e) => setForm({ ...form, last_name: e.target.value })}
                                                />
                                            </div>

                                            {/* ADDRESS */}
                                            <div className="col-lg-12 mb-3">
                                                <label>
                                                    Address <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Address"
                                                    rows="3"
                                                    value={form.address}
                                                    onChange={(e) => setForm({ ...form, address: e.target.value })}
                                                ></textarea>
                                            </div>

                                            {/* STATE */}
                                            <div className="col-lg-4 col-md-4 col-sm-6">
                                                <label htmlFor="state">State<sup>*</sup></label><br />
                                                <select id="state" name="state" className="form-control" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })}>
                                                    <option value="">Select State</option>
                                                    {states.map((state) => (
                                                        <option key={state.state_id} value={state.state_id}>{state.state_name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* CITY */}
                                            <div className="col-lg-4 col-md-4 col-sm-6">
                                                <label htmlFor="city">City<sup>*</sup></label><br />
                                                <select id="city" name="city" className="form-control" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })}>
                                                    <option value="">Select City</option>
                                                    {cities.map((city) => (
                                                        <option key={city.city_id} value={city.city_id}>{city.city_name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* PIN CODE */}
                                            <div className="col-lg-4 mb-3">
                                                <label>
                                                    Pin Code <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Pin Code"
                                                    value={form.pin_code}
                                                    onChange={(e) => setForm({ ...form, pin_code: e.target.value })}
                                                />
                                            </div>

                                            {/* EMAIL */}
                                            <div className="col-lg-6 mb-3">
                                                <label>Email Id</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Email"
                                                    value={form.email_id}
                                                    onChange={(e) => setForm({ ...form, email_id: e.target.value })}
                                                />
                                            </div>

                                            {/* PHONE */}
                                            <div className="col-lg-6 mb-3">
                                                <label>
                                                    Phone Number <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Phone Number"
                                                    value={form.phone_number}
                                                    onChange={(e) => setForm({ ...form, phone_number: e.target.value })}
                                                />
                                            </div>

                                            {/* BUTTONS */}
                                            <div className="col-lg-12 mt-3 d-flex">
                                                <button
                                                    style={{
                                                        background: "#227070",
                                                        border: "none",
                                                        color: "#fff",
                                                        width: "20%",
                                                        borderRadius: "10px",
                                                        fontSize: "18px",
                                                        marginRight: "20px",
                                                        padding: "10px 20px",
                                                    }}
                                                    onClick={handleSubmit}
                                                >
                                                    {editMode ? "UPDATE" : "SUBMIT"}
                                                </button>

                                                <button
                                                    style={{
                                                        border: "1px solid #227070",
                                                        color: "#227070",
                                                        background: "transparent",
                                                        borderRadius: "10px",
                                                        padding: "10px 20px",
                                                        fontSize: "18px",
                                                    }}
                                                    onClick={() => {
                                                        setShowAddressForm(false);
                                                        setEditMode(false);
                                                    }}
                                                >
                                                    CANCEL
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* ADDRESS LIST */}
                                <div className="row mt-4">
                                    {addressList.map(item => (
                                        <React.Fragment key={item.address_id}>

                                            {/* SHOW WARNING ABOVE THIS ADDRESS ONLY IF NOT ADD/EDIT MODE */}
                                            {!showAddressForm && item.shipping_status === 0 && item.address_id === selectedCardId && (
                                                <div className="error-message" style={{ marginBottom: "10px", color: "red" }}>
                                                    Delivery is not available for this pincode
                                                </div>
                                            )}

                                            <div
                                                className={item.address_id === selectedCardId ? "selected-address-card" : "address-card"}
                                                onClick={() => selectCard(item.address_id)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <div className="inneraddress">
                                                    <h5>{item.first_name} {item.last_name}</h5>
                                                    <p>{item.address}</p>
                                                    <p><b>{item.phone_number}</b></p>
                                                </div>

                                                <div className="address-card-btn">
                                                    <button onClick={(e) => handleRemoveAddress(e, item.address_id)}>Remove</button>
                                                    <button onClick={(e) => handleEdit(e, item)}>Edit</button>
                                                </div>
                                            </div>

                                        </React.Fragment>
                                    ))}
                                </div>


                            </div>

                            {/* RIGHT SIDE */}
                            <div className="col-lg-4">
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "20px",
                                        paddingBottom: "25px",
                                        width: "380px",
                                        margin: "auto",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                                    }}
                                >
                                    <h4
                                        style={{
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            marginBottom: "20px",
                                            fontSize: "23px",
                                            borderTopLeftRadius: "20px",
                                            borderTopRightRadius: "20px",
                                            padding: "10px",
                                            background: "#e7e7e7",
                                        }}
                                    >
                                         TOTAL
                                    </h4>

                                    {!productData ? (
                                        <p style={{ textAlign: "center" }}>Loading...</p>
                                    ) : (
                                        <>
                                            {/* Cart Items Quantity */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    color: "#000",
                                                    padding: "0 25px",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                <span style={{ fontWeight: "500" }}>Cart Items</span>
                                                <span>{productData.product?.selected_quantity}</span>
                                            </div>

                                            <hr />

                                            {/* Product Name, Size, Price */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    color: "#000",
                                                    padding: "0 25px",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                <span style={{ maxWidth: "70%", fontSize: "14px" }}>
                                                    {productData.product?.name} (Size: {productData.product?.selected_size_name})
                                                </span>
                                                <span>₹{productData.product_total}</span>
                                            </div>

                                            <hr />
                                            <div
                                                className="cart-itemcont double-border"
                                                onClick={showCoupon ? coupannav : undefined}
                                                style={{
                                                    cursor: showCoupon ? "pointer" : "default",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    color: "#227070",
                                                    padding: "0 25px",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                {showCoupon ? (
                                                    <>
                                                        <h6>Select Coupon</h6>
                                                        <FontAwesomeIcon icon={faAngleRight} />
                                                    </>
                                                ) : (
                                                    <>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <h6 style={{ margin: 0 }}>{couponDetail?.coupon_name}</h6>
                                                            <span style={{ fontSize: "13px", color: "green" }}>
                                                                ₹{couponDetail?.discount_amount} OFF Applied
                                                            </span>
                                                        </div>

                                                        <FontAwesomeIcon
                                                            icon={faXmark}
                                                            style={{ cursor: "pointer", color: "red" }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                removeCoupon();
                                                            }}
                                                        />
                                                    </>
                                                )}
                                            </div>


                                            <hr />

                                            {/* Subtotal */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    padding: "0 25px",
                                                    marginBottom: "8px",
                                                    color: "#000",
                                                }}
                                            >
                                                <span>Subtotal</span>
                                                <span>₹{productData.product_total}</span>
                                            </div>

                                            <hr />


                                            {/* Shipping Rate */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    padding: "0 25px",
                                                    marginBottom: "8px",
                                                    color: "#000",
                                                }}
                                            >
                                                <span>Shipping Charge</span>
                                                <span>₹{productData.shipping_rate}</span>
                                            </div>

                                            <hr />

                                            {/* Total Amount */}
                                            <div
                                                style={{
                                                    padding: "0 25px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    fontSize: "18px",
                                                    marginBottom: "20px",
                                                }}
                                            >
                                                <strong>Grand Total</strong>

                                                <strong>₹{productData.total_amount}</strong>
                                            </div>

                                            {/* Proceed Button */}
                                            <button
                                                style={{
                                                    width: "40%",
                                                    padding: "10px 20px",
                                                    background: "#92ad69",
                                                    border: "none",
                                                    borderRadius: "10px",
                                                    color: "white",
                                                    fontSize: "18px",
                                                    fontWeight: "500",
                                                    cursor: "pointer",
                                                    display: "block",
                                                    margin: "0 auto",
                                                }}
                                                onClick={handlePayment}
                                                disabled={disablePay || isLoading || !selectedCardId}
                                            >
                                                {isLoading ? (
                                                    <><FontAwesomeIcon icon={faSpinner} spin /> Processing...</>
                                                ) : (
                                                    "Proceed To Pay"
                                                )}
                                            </button>

                                        </>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Buynow;
